import { useState, useEffect } from "react";
import EditIcon from "@mui/icons-material/Edit";
import { Typography, Box, Tooltip, IconButton, InputBase } from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { UseGeneralPages } from "./UseGeneralPages";
import { useNavigate, useLocation } from "react-router-dom";
import CustomPagination from "../../components/CustomPagination";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import {
  rsProgress,
  rsActiveMenu,
  rsRefreshContentPage,
} from "../../RecoilStates";
import { useRecoilState } from "recoil";

export default function GeneralPages() {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const location = useLocation();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const navigate = useNavigate();
  const { GetGeneralPages } = UseGeneralPages();
  const [searchSubGroup, setSearchSubGroup] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [filt, setFilt] = useState([]);
  const [pageRes, setpageRes] = useState();
  const [pageState, setPageState] = useState({
    page: 1,
  });

  useEffect(() => {
    setProgress(true);
    GetGeneralPages(true, (Pages) => {
      setpageRes(Pages);
    });
  }, []);

  useEffect(() => {
    setFilt([
      {
        columnField: "title",
        operatorValue: "contains",
        value: searchSubGroup,
      },
    ]);
  }, [searchSubGroup]);

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "id",
      headerAlign: "center",
    },
    {
      field: "pagename",
      headerName: "نام صفحه",
      width: 220,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "title",
      headerName: "عنوان",
      width: 250,
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.title}
          </Typography>
        );
      },
    },
    {
      field: "ویرایش",
      sortable: false,
      width: 100,
      headerAlign: "center",
      align: "center",
      headerName: "ویرایش",
      renderCell: (cellValues) => {
        return (
          <Tooltip title="ویرایش">
            <IconButton
              onClick={() => {
                return navigate("/generalpages/pageDetail", {
                  state: {
                    search: searchSubGroup,
                    id: cellValues.row.id,
                  },
                });
              }}
            >
              <EditIcon sx={{ color: "MyColor.main" }} />
            </IconButton>
          </Tooltip>
        );
      },
    },
    {
      field: "search",
      width: 200,
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <Box
            sx={{ border: "1px solid #d3d3d3", borderRadius: 1 }}
            width="auto"
            display="flex"
            justifyContent="flex-start"
          >
            <InputBase
              sx={{ ml: 2, flex: 1 }}
              placeholder="جستجو"
              value={searchSubGroup}
              inputProps={{ "aria-label": "search" }}
              onChange={(evt) => {
                setSearchSubGroup(evt.target.value);
              }}
            />
          </Box>
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        title: "مدیریت محتوا",
        childs: [{ name: msActiveMenu.pageTitle, url: "/generalpages" }],
      }}
    >
      {pageRes ? (
        <DataGrid
          filterModel={{
            items: filt,
          }}
          className="ltr-grid"
          localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
          columns={columns}
          rows={pageRes ? pageRes : []}
          page={pageState.page - 1}
          pageSize={20}
          Pagination
          onPageChange={(newPage) => {
            setPageState((old) => ({ ...pageState, page: newPage + 1 }));
          }}
          rowCount={pageRes && pageRes.length ? pageRes.length : 1}
          enableRangeSelection={true}
          disableColumnMenu
          hideFooterSelectedRowCount
          components={{
            Pagination: CustomPagination,
          }}
          disableMultipleColumnsFiltering={false}
          componentsProps={{
            pagination: {
              isLtr: true,
              nofab: true,
              rowCount: pageRes && pageRes.length ? pageRes.length : "",
            },
          }}
          initialState={{
            sorting: {
              sortModel: [
                {
                  field: "rowIndex",
                  sort: "asc",
                },
              ],
            },
          }}
        />
      ) : (
        <ProgressCom></ProgressCom>
      )}
    </Detail>
  );
}
